import React from 'react';
import { StackedBarChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToKeyGroupValue, buildChartTitle, buildXAxisTitle, buildYAxisTitle, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = transformToKeyGroupValue(panelData, chart);
                const maxValue = Math.max(...data.map(d => d.value), 0) * 1.2 || 10;
                const colorScale = buildColorScale(data);
                const options = {
                    title: buildChartTitle(chart),
                    height: '400px',
                    axes: {
                        left: {
                            title: buildYAxisTitle(chart),
                            mapsTo: 'value',
                            scaleType: 'linear',
                            stacked: true,
                            domain: [0, maxValue]
                        },
                        bottom: {
                            title: buildXAxisTitle(chart),
                            mapsTo: 'key',
                            scaleType: 'labels'
                        }
                    },
                    color: { scale: colorScale }
                };
                return <StackedBarChart options={options} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
